
import { Vue, Component, ModelSync, Prop } from "vue-property-decorator";

@Component({})
export default class OxyIndicatorLights extends Vue {
  @ModelSync("value", "input")
  syncedValue?: unknown;

  @Prop({ default: true })
  resetOnClick!: boolean;

  resetControl() {
    if (!this.resetOnClick) return;
    this.syncedValue = undefined;
  }
}
